import { render, staticRenderFns } from "./alimony.vue?vue&type=template&id=056cb6db&scoped=true"
import script from "./alimony.vue?vue&type=script&lang=js"
export * from "./alimony.vue?vue&type=script&lang=js"
import style0 from "./alimony.vue?vue&type=style&index=0&id=056cb6db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056cb6db",
  null
  
)

export default component.exports